<template>
  <div>
    <div class="lg:flex gap-5 md:flex container mx-auto">
      <div class="lg:mt-0 md:mt-0 mt-0 lg:w-1/2 md:w-1/2">
        <!-- src="@/assets/images/about/300image.png" -->
        <div class="hoverText1" id="6009564432">
          <img
            :src="getImage(pageData['6009564432'])"
            alt="img"
            class="object-contain w-full"
          />
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 m-auto flex lg:mr-10 md:mr-10 mr-0">
        <div class="m-auto truncate">
          <!-- @click="handleClick('product-designs')" -->
          <div
            class="flex lg:gap-4 md:gap-4 gap-2 justify-center lg:mr-24 md:mr-8 mr-4 mb-0"
          >
            <!-- <img
            :src="`${$imageURL}`+item.subcatImage"
            :alt="item.subcategoryName"
            class="w-135 h-154 sm-h-80 sm-w-80 object-contain cursor-pointer"
          /> -->
            <!-- src="@/assets/images/hexagon series/metallic.png" -->
            <div id="2148347659" class="hoverText1">
              <img
                :src="getImage(pageData['2148347659'])"
                @click="handleClickSubcategory('product-designs', 'metallic')"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/solid.png" -->
            <div id="6621639262" class="hoverText1">
              <img
                :src="getImage(pageData['6621639262'])"
                @click="handleClickSubcategory('product-designs', 'solid')"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/woodentexture.png" -->
            <div id="2802185380" class="hoverText1">
              <img
                :src="getImage(pageData['2802185380'])"
                @click="
                  handleClickSubcategory('product-designs', 'wooden-texture')
                "
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/highgloss.png" -->
            <div id="7760877134" class="hoverText1">
              <img
                :src="getImage(pageData['7760877134'])"
                @click="handleClickSubcategory('product-designs', 'high-gloss')"
                alt="honey-comb"
                class="w-135 hoverText1 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
          </div>
          <div
            class="flex justify-center lg:ml-16 md:ml-8 cust-margin-top-23 sm-margin-top ml-10 lg:gap-4 md:gap-4 gap-2 mb-0"
          >
            <!-- src="@/assets/images/hexagon series/zcpseries.png" -->
            <div
              id="2741105289"
              class="w-135 md-h-85 hoverText1 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'zcp')"
                :src="getImage(pageData['2741105289'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/sparkle.png" -->
            <div
              id="8546367389"
              class="w-135 md-h-85 hoverText1 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'sparkle')"
                :src="getImage(pageData['8546367389'])"
                alt="honey-comb"
                class="w-135 h-154 md-h-85 sm-h-80 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/mirror.png" -->
            <div
              id="2077399747"
              class="w-135 md-h-85 hoverText1 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'mirror')"
                :src="getImage(pageData['2077399747'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/hpl.png" -->
            <div
              id="1403242415"
              class="w-135 md-h-85 hoverText1 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'hpl')"
                :src="getImage(pageData['1403242415'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
          </div>
          <div
            class="flex justify-center cust-margin-top-23 sm-margin-top lg:gap-4 md:gap-4 gap-2 lg:mr-24 md:mr-8 mr-4 mb-0"
          >
            <!-- src="@/assets/images/hexagon series/brush.png" -->
            <div
              id="6329191274"
              class="w-135 hoverText1 md-h-85 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'brush')"
                :src="getImage(pageData['6329191274'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/wooden.png" -->
            <div
              id="7532395470"
              class="w-135 hoverText1 md-h-85 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'wooden')"
                :src="getImage(pageData['7532395470'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/stone.png" -->
            <div
              id="3474839623"
              class="w-135 hoverText1 md-h-85 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'stone')"
                :src="getImage(pageData['3474839623'])"
                alt="honey-comb"
                class="w-135 hoverText1 h-154 md-h-85 sm-h-80 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/marble.png" -->
            <div
              id="0865739508"
              class="w-135 hoverText1 md-h-85 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="handleClickSubcategory('product-designs', 'marble')"
                :src="getImage(pageData['0865739508'])"
                alt="honey-comb"
                class="w-135 hoverText1 h-154 md-h-85 sm-h-80 sm-w-80 object-contain cursor-pointer"
              />
            </div>
          </div>

          <div
            class="flex justify-center lg:ml-16 md:ml-8 cust-margin-top-23 sm-margin-top ml-10 lg:gap-4 md:gap-4 gap-2"
          >
            <!-- src="@/assets/images/hexagon series/timeless.png" -->
            <div
              id="0102336489"
              class="hoverText1 w-135 md-h-85 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="
                  handleClickSubcategory('product-designs', 'timeless-designs')
                "
                :src="getImage(pageData['0102336489'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/authentic.png" -->
            <div
              id="6023471236"
              class="hoverText1 w-135 md-h-85 h-154 sm-h-80 sm-w-80"
            >
              <img
                @click="
                  handleClickSubcategory(
                    'product-designs',
                    'authentic-textures'
                  )
                "
                :src="getImage(pageData['6023471236'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <div
              id="9789420395"
              class="hoverText1 w-135 md-h-85 h-154 sm-h-80 sm-w-80"
            >
              <!-- src="@/assets/images/hexagon series/glam.png" -->
              <img
                @click="
                  handleClickSubcategory('product-designs', 'glamourous-jewels')
                "
                :src="getImage(pageData['9789420395'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <div
              id="1804409022"
              class="hoverText1 w-135 h-154 md-h-85 sm-h-80 sm-w-80"
            >
              <!-- src="@/assets/images/hexagon series/zinc.png" -->
              <img
                @click="handleClickSubcategory('product-designs', 'zinc')"
                :src="getImage(pageData['1804409022'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
          </div>
          <div
            class="flex justify-center cust-margin-top-23 sm-margin-top lg:gap-4 md:gap-4 gap-2 lg:mr-24 md:mr-8 mr-4 mb-0"
          >
            <!-- src="@/assets/images/hexagon series/midastouch.png" -->
            <div id="6300840780" class="w-135 hoverText1 h-154 sm-h-80 sm-w-80">
              <img
                @click="
                  handleClickSubcategory('product-designs', 'midas-touch')
                "
                :src="getImage(pageData['6300840780'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/sandseries.png" -->
            <div id="4585408384" class="w-135 hoverText1 h-154 sm-h-80 sm-w-80">
              <img
                @click="handleClickSubcategory('product-designs', 'sand')"
                :src="getImage(pageData['4585408384'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/finetexture.png" -->
            <div id="1172041311" class="w-135 hoverText1 h-154 sm-h-80 sm-w-80">
              <img
                @click="
                  handleClickSubcategory('product-designs', 'fine-texture')
                "
                :src="getImage(pageData['1172041311'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
            <!-- src="@/assets/images/hexagon series/mattyclay.png" -->
            <div id="2076255075" class="w-135 hoverText1 h-154 sm-h-80 sm-w-80">
              <img
                @click="handleClickSubcategory('product-designs', 'matte-clay')"
                :src="getImage(pageData['2076255075'])"
                alt="honey-comb"
                class="w-135 h-154 sm-h-80 md-h-85 sm-w-80 object-contain cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isShowCMS: false,
      pageData: {},
      selectedId: "",
      direction: "rtl",
    };
  },
  watch: {
    isShowCMS(newValue) {
      console.log(newValue);
    },
    pages(value) {
      this.pageData = value["Eurocomb"];
    },
  },
  computed: {
    ...mapState("cms", ["pages", "user"]),
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleClickSubcategory(path, subcategory) {
      this.$router.push({ path, query: { subcategory } });
    },
    getImage(image) {
      if (image && image.includes("data:image/")) {
        return image;
      } else {
        if (image) {
          return `${process.env.VUE_APP_STORAGE_URL}${image}`;
        } else {
          return "https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg";
        }
      }
    },
    async removeClass() {
      let classData = document.getElementsByClassName("hoverText1");

      const elementsArray = Array.from(classData);

      elementsArray.forEach((element) => {
        element.classList.remove("hoverText1");
      });
    },

    addClass() {
      let classData2 = document.getElementsByClassName("hoverText1");

      let classData = document.getElementsByClassName("hoverText1");
      console.log(classData, "home");
      for (let i = 0; i < classData.length; i++) {
        classData[i].classList.add("hoverText1");
        if (classData[i]) {
          console.log(classData[i].id, "ids");
          classData[i].addEventListener("click", () => {
            this.selectedId = classData[i].id;
            console.log(this.selectedId, "selected");
            this.isShowCMS = true;
          });
        }
      }
    },

    async closePopup2() {
      console.log("close");
      this.isShowCMS = false;
      let cms = { projectName: process.env.VUE_APP_COMMUNITY_NAME };
      await this.$store.dispatch("cms/getClientCms", cms);
    },
    init() {
      let popVal = localStorage.getItem("pop");
      let val = Boolean(popVal);
      if (!val) {
        localStorage.setItem("pop", false);
      } else {
        localStorage.setItem("pop", true);
        let pop = localStorage.getItem("pop");
        this.AdPopup = Boolean(pop);
      }
    },
    async closeModal() {
      localStorage.setItem("pop", false);
      this.AdPopup = false;
    },
  },
  async mounted() {
    this.init();
    if (this.pages) {
      this.pageData = this.pages["Eurocomb"];
    }

    if (this.$route.query.token === "123") {
      console.log("CMS Active");
      await this.addClass();
    } else {
      await this.removeClass();
    }
  },
};
</script>
<style>
.w-135 {
  width: 135px !important;
}
.w-235px {
  width: 235px;
}
.h-154 {
  height: 154px !important;
}

.cust-margin-top-23 {
  margin-top: -23px;
}
@media (max-width: 640px) {
  .sm-w-80 {
    width: 80px !important;
  }
  .sm-h-80 {
    height: 80px !important;
  }
  .sm-margin-top {
    margin-top: -2px;
  }
}
@media (max-width: 768px) and (min-width: 641px) {
  .md-h-85 {
    height: 85px !important;
  }
}
</style>
